import { createSlice } from "@reduxjs/toolkit";

let initialState = {
    allGlobalOrders: [],
    filteredGlobalOrders: [],
    currentOrder: null,
    total: 0,
    hasMore: false,
    loading: false,
    error: null
};

let GlobalOrdersSlice = createSlice({
    name: "globalOrders",
    initialState: initialState,
    reducers: {
        setGlobalOrders: (state, action) => {
            state.allGlobalOrders = action.payload.orders || [];
            state.total = action.payload.total || 0;
            state.hasMore = action.payload.has_more || false;
            state.loading = false;
            state.error = null;
        },
        appendGlobalOrders: (state, action) => {
            state.allGlobalOrders = [...state.allGlobalOrders, ...(action.payload.orders || [])];
            state.hasMore = action.payload.has_more || false;
            state.loading = false;
        },
        setFilteredGlobalOrders: (state, action) => {
            state.filteredGlobalOrders = action.payload;
        },
        setCurrentGlobalOrder: (state, action) => {
            state.currentOrder = action.payload;
        },
        updateGlobalOrderInList: (state, action) => {
            const { orderId, orderData } = action.payload;
            state.allGlobalOrders = state.allGlobalOrders.map((order) =>
                order.id === orderId ? { ...order, ...orderData } : order
            );
            state.filteredGlobalOrders = state.filteredGlobalOrders.map((order) =>
                order.id === orderId ? { ...order, ...orderData } : order
            );
            if (state.currentOrder && state.currentOrder.id === orderId) {
                state.currentOrder = { ...state.currentOrder, ...orderData };
            }
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        clearGlobalOrders: (state) => {
            state.allGlobalOrders = [];
            state.filteredGlobalOrders = [];
            state.currentOrder = null;
            state.total = 0;
            state.hasMore = false;
        }
    }
});

export let {
    setGlobalOrders,
    appendGlobalOrders,
    setFilteredGlobalOrders,
    setCurrentGlobalOrder,
    updateGlobalOrderInList,
    setLoading,
    setError,
    clearGlobalOrders
} = GlobalOrdersSlice.actions;

export default GlobalOrdersSlice.reducer;


